import React, { useState, useEffect } from "react";
import "./hero.css";

import { Container, Row, Col, Form, InputGroup, Button } from "react-bootstrap";
import { BsSearch } from "react-icons/bs";
import { motion, AnimatePresence } from "framer-motion";

import DesignImage from "../../images/topics/undraw_Remote_design_team_re_urdx.png";
import Rightimage from "../../images/feature2.jpg";

const Hero = () => {
  const subtitles = [
    "Professional Websites, Apps & Software Solutions",
    "Custom Websites for Businesses & Students.",
    "Transforming Ideas into Powerful Digital Solutions.",
  ];

  const [currentText, setCurrentText] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prev) => (prev + 1) % subtitles.length);
    }, 5500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Hero Section */}

      <section className="hero-section d-flex align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} md={10} xs={12} className="text-center">
              <motion.h1
                className="hero-title"
                initial={{ opacity: 0, y: -40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                Your Vision, Our Technology.
              </motion.h1>

              <div className="subtitle-wrapper">
                <AnimatePresence mode="wait">
                  <motion.p
                    key={currentText}
                    className="hero-subtitle"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.6 }}
                  >
                    {subtitles[currentText]}
                  </motion.p>
                </AnimatePresence>
              </div>

              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.8 }}
              >
                <Form className="hero-search-form">
                  <InputGroup>
                    <InputGroup.Text className="search-icon">
                      <BsSearch />
                    </InputGroup.Text>

                    <Form.Control
                      placeholder="Search Websites, Android Apps, Final Year Projects..."
                    />

                    <Button className="search-btn">
                      Search
                    </Button>
                  </InputGroup>
                </Form>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Featured Section */}

      <section className="featured-section">
        <Container>
          <Row className="justify-content-center">

            {/* Left Card */}

            <Col lg={4} md={6}>
              <motion.div
                className="custom-block"
                initial={{ opacity: 0, x: -60 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <div className="card-header-custom">
                  <div>
                    <h4>Web Design</h4>

                    <p>
                      When you search for free CSS templates,
                      you will notice that TemplateMo is one
                      of the best websites.
                    </p>
                  </div>

                  
                </div>

              </motion.div>
            </Col>

            {/* Right Card */}

            <Col lg={6} md={6}>
              <motion.div
                className="overlay-card"
                initial={{ opacity: 0, x: 60 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <img
                  src={Rightimage}
                  alt="Rightimage"
                  className="overlay-image"
                />

                <div className="overlay"></div>

                <div className="overlay-content">
                  <div>
                    <h4>Finance</h4>

                    <p>
                      Topic Listing Template includes homepage,
                      listing page, detail page, and contact page.
                      You can feel free to edit and adapt for your
                      CMS requirements.
                    </p>

                    <Button className="learn-btn">
                      Learn More
                    </Button>
                  </div>

                 
                </div>
              </motion.div>
            </Col>

          </Row>
        </Container>
      </section>
    </>
  );
};

export default Hero;    